module.exports = __webpack_public_path__ + "static/media/PC_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.cb93f3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arq_infra/PC_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png
// module id = 91
// module chunks = 0